import React, { useState } from 'react'
import axios from 'axios'
import decode from 'jwt-decode'
import { Popup } from 'devextreme-react/popup'
import styled from 'styled-components'
import { useSetRecoilState } from 'recoil'
import TextBox from 'devextreme-react/text-box'
import { Validator, RequiredRule } from 'devextreme-react/validator'
import Button from 'devextreme-react/button'
import { useTranslation } from "react-i18next"

//import recoil
import { userState } from '../../recoil/atoms'
import { notify } from "../common/M2WEBNotify"
//import function
// import { login, clearLocalstorage } from "../../utils/authentication"

const LogoutLink = styled.span`
    margin-top: 1em;    
    color: gray;
    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }
`

const LoginPopup = ({
	isOpen,
	toggle
}) => {
	const { t } = useTranslation()

	const setUserState = useSetRecoilState(userState)

	const [isLoading, setIsLoading] = useState(false)
	const [username, setUsername] = useState(localStorage.getItem('loginName'))
	const [password, setPassword] = useState('')

	const handleSubmit = async (e) => {
		try {
			setIsLoading(true)
			e.preventDefault()
			const res = await login(username, password)
			const { token } = res
			localStorage.setItem('token', token)
			setUserState(res)
			setIsLoading(false)
			toggle()
			clearInput()
		} catch (err) {
			setIsLoading(false)
			console.log('Error on handleSubmit function')
		}
	}

	const handleLogout = async () => {
		toggle()
		clearInput()
		clearLocalstorage()
	}

	const handleUsernameChange = ({ value }) => {
		setUsername(value)
	}

	const handlePasswordChange = ({ value }) => {
		setPassword(value)
	}

	const clearInput = () => {
		setUsername('')
		setPassword('')
	}

	const login = (username, password) => {
		return new Promise(async (resolve, reject) => {
			try {
				const url = `${process.env.REACT_APP_API_URL}/api/v1/Users/login`
				const payload = {
					loginName: username,
					password: password
				}
				const { data: { token } } = await axios.post(url, payload)
				const { loginName, firstName, userId, roles, exp } = decode(token)
				const result = {
					token,
					loginName,
					firstName,
					userId,
					roles,
					exp
				}
				return resolve(result)
			} catch (err) {
				const { message = '' } = err?.response?.data || {}
				notify('error', `${t('Login failed')}!\n${message}`)
				return reject(null)
			}
		})
	}

	const clearLocalstorage = () => {
		try {
			localStorage.removeItem('token')
		} catch (err) {
			notify('error', `Error on clearLocalstorage function`)
		}
	}

	const loginCaption = isLoading ? 'Logging in' : 'Log in'

	return (
		<Popup
			visible={isOpen}
			dragEnabled={false}
			closeOnOutsideClick={false}
			showCloseButton={false}
			showTitle={true}
			title={t("Session Expired, Please Login")}
			width={window.screen.width >= 400 && window.screen.width <= 800 ? 380 : 500}
			height={280}
		>
			<form id="login-popup-form" action='#' className='d-flex flex-column align-items-center' onSubmit={handleSubmit}>
				<TextBox
					className='mb-2 w-100'
					type='TextBox'
					placeholder={t('Username')}
					value={username}
					onValueChanged={handleUsernameChange}
				>
					<Validator name="login-popup">
						<RequiredRule message={t("Username is required")} />
					</Validator>
				</TextBox>
				<TextBox
					className='mb-2 w-100'
					type='TextBox'
					mode='password'
					name='password'
					placeholder={t('Password')}
					value={password}
					onValueChanged={handlePasswordChange}
				>
					<Validator name="login-popup">
						<RequiredRule message={t("Password is required")} />
					</Validator>
				</TextBox>
				<Button className="mt-3" width="200px" text={t(loginCaption)} type="default" stylingMode="outlined" useSubmitBehavior={true} validationGroup="login-popup" />
				<LogoutLink onClick={handleLogout}>{t('Log out')}</LogoutLink>
			</form>
		</Popup>
	)
}

export default LoginPopup